import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'baas-icon-text, baas-field',
    templateUrl: './baas-field.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTooltip],
    host: { class: 'lv-field' }
})
export class BaasField {
    /** Font Awesome class(es) for the icon, e.g. 'fa-calendar' */
    readonly iconClass = input<string>();
    /** Optional bold label shown between icon and text */
    readonly label = input<string>();
    /** Value text */
    readonly text = input.required<string>();
    /** Optional tooltip shown on hover */
    readonly tooltip = input<string>();
}

/** @deprecated Use BaasField instead. */
export { BaasField as BaasIconText };
